<template>
  <b-modal title="درخواست صدور مدرک" id="licenseRequest" no-close-on-esc header-close-variant="dark" hide-footer centered>
    <div v-if="type == 3" class="my-3">
      <div>{{ count }} نفر از دانش پذیران اطلاعات پروفایلشان ناقص است.</div>
      <div class="mt-2">متاسفانه سیستم قادر به صدور مدرک نیست لطفا دانش پذیرانی که پورفایلشان کامل نیست حذف یا تکمیل اطلاعات شوند.</div>
    </div>
    <div v-if="type == 2" class="my-3">
      <div>نمره {{ count }} نفر از دانش پذیران وارد نشده است.</div>
      <div class="mt-2">متاسفانه سیستم قادر به صدور مدرک نیست لطفا برای همه دانش پذیران نمره ثبت کنید.</div>
    </div>
    <div class="d-flex justify-content-end align-items-center mt-3 gap-2">
      <b-button variant="primary" @click="$bvModal.hide('licenseRequest')">متوجه شدم</b-button>
    </div>
  </b-modal>
</template>
<script>
export default {
  props: {
    type: Number,
    count: String,
  },
  data() {
    return {
      showModal: true,
    }
  },
}
</script>
